export class LinearSliderScale {
  constructor(start, end) {
    this._start = start;
    this._end = end;
    this._length = end - start;
  }
  position(value) {
    // TODO: probably move this to an internal adapter so everyone doesn't have
    //     | to implement this check.
    if (this._start === this._end) {
      return 0;
    }
    return (value - this._start) / this._length;
  }
  value(position) {
    return position * this._length + this._start;
  }
  get minValue() {
    return this._start;
  }
  get maxValue() {
    return this._end;
  }
  static createFromLength(start, length) {
    return new LinearSliderScale(start, start + length);
  }
  static createFromMinMax(start, end) {
    return new LinearSliderScale(start, end);
  }
}
//# sourceMappingURL=SliderScale.js.map